module.exports = __webpack_public_path__ + "img/reporting.79a7e1a5.svg";